import { Controller } from '@hotwired/stimulus';
import { tns } from 'tiny-slider/src/tiny-slider';

// Posé sur le parent des diapositives : tiny-slider déplace son conteneur dans
// le DOM, ce qui déconnecterait puis reconnecterait un contrôleur posé dessus.
export default class SliderController extends Controller<HTMLElement> {
  static targets = ['container'];

  declare readonly containerTarget: HTMLElement;

  connect(): void {
    tns({
      container: this.containerTarget,
      autoplay: true,
      autoplayButtonOutput: false,
      autoplayHoverPause: true,
      controls: false,
    });
  }
}
